import React from 'react';
import GeneralIcon from '../assets';

export default function AuthLayout({ title, children, widthClass = 'w-80' }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white text-gray-800 pt-8">
      <div className={`${widthClass}`}>
        <div className="flex items-center justify-center mb-3">
          <GeneralIcon iconName="geppro_seller" className="w-40 h-auto" />
        </div>
        {title && (
          <h2 className="text-2xl md:text-3xl font-semibold mb-6 text-center text-gray-900">
            {title}
          </h2>
        )}
        {children}
      </div>
    </div>
  );
}
